export enum DashboardKpiTimeRange {
  ONE_DAY = '1',
  SEVEN_DAYS = '7',
  THIRTY_DAYS = '30',
  ALL = 'all',
}
